<template>
  <div class="project-picture">
    <div class="img-wrap">
      <el-carousel height="532px" indicator-position="none">
        <el-carousel-item v-for="(item, i) in showBannerList" :key="i">
          <div class="shapan-tip" v-if="item.type === 'shapan'" @click="shapanDetail(item)"></div>
          <div class="video-btn" v-if="item.type === 'video'" @click="watchDetail(item)">
            <!-- <i class="el-icon-arrow-right"/> -->
          </div>
          <el-image style="height: 532px; cursor: pointer;" :src="item.pic" fit="cover" alt="" v-if="item.type === 'shapan'"/>
          <el-image style="height: 532px; cursor: pointer;" :src="item.pic" fit="cover" alt="" v-if="item.type === 'picture'" :preview-src-list="srcList"/>
          <el-image style="height: 532px; cursor: pointer;" :src="item.pic" fit="cover" alt="" v-if="item.type === 'video'" @click="watchDetail(item)"/>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="small-pics" v-if="banner && banner.length">
      <div class="left-btn" @click="prev">
        <i class="el-icon-arrow-left"/>
      </div>
      <div class="pic-wrap">
        <template v-for="(item, index) in banner">
          <div class="pic" :key="index" @click="changePicList(item, index)">
            <img :src="item.cover" alt="banner">
            <div class="type-name" :class="{active: active === index}">
              <span>{{item.label}}</span><span>（{{ item.list.length }}) </span>
            </div>
          </div>
        </template>
      </div>
      <div class="right-btn" @click="next">
        <i class="el-icon-arrow-right"/>
      </div>
    </div>
    <pop-dialog :show.sync="dialogVisible" class="pop-dialog-wrap">
      <div class="video-prev" @click="preVideo">
        <i class="el-icon-arrow-left"></i>
      </div>
      <video ref="vueRef" controls preload style="height: 100%; width: 100%" :src="activeVideoInfo.url"/>
      <div class="video-next" @click="nextVideo">
        <i class="el-icon-arrow-right"></i>
      </div>
    </pop-dialog>
    <a target="_blank" :href="shapanVrUrl"><span id="tag2"></span></a>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import popDialog from './PopDialog.vue'

export default {
  name: 'project-picture',
  components: {
    popDialog,
  },
  data () {
    return {
      showBannerList: [],
      srcList: [],
      active: 0,
      showBannerActive: 0,
      title: '',
      dialogVisible: false,
      activeVideoInfo: {
        url: '',
        type: ''
      },
      shapanVrUrl: '',
      dialogVrVisible: false
    }
  },
  computed: {
    ...mapGetters([
      'projectDetailFlatImages',
      'projectResources',
      'projectDetail',
    ]),
    showResource () {
      return this.projectResources && this.projectResources.length
    },
    showPicture () {
      return  this.projectDetailFlatImages && this.projectDetailFlatImages.length
    },
    showVideo () {
      return this.videoList && this.videoList.length
    },
    videoList () {
      return (this.projectDetail && this.projectDetail.videoList) || []
    },
    banner () {
      let pictures = [], shapan = [], video = []
      pictures = this.projectDetailFlatImages.map(pic => {
        return {
          type: 'picture',
          pic,
        }
      })
      if (this.showResource) {
        shapan = this.projectResources.map(item => {
          const shapanItem = {
            type: 'shapan',
            pic: item.coverImg || item.previewImg,
            vrUrl: item.vrUrl,
            vrUrlPc: item.vrUrlPc,
            rid: item.rid,
            pcRid: item.pcRid,
          }
          return shapanItem
        })
      }
      if (this.showVideo) {
        const videoImageOss = 'x-oss-process=video/snapshot,t_1000,f_jpg,w_686,h_352,m_fast'
        video = this.videoList.map(item => {
          return {
            type: 'video',
            pic: item.videoCoverPicture || `item.coverVideo?${videoImageOss}`,
            url: item.coverVideo,
          }
        })
      }
      const arr = []
      if (shapan.length) {
        arr.push({type: 'shapan', label: '沙盘', list: shapan, cover: shapan[0].pic })
      }
      if (video.length) {
        arr.push({type: 'video', label: '视频', list: video, cover: video[0].pic})
      }
      if (pictures.length) {
        arr.push( {type: 'picture', label: '图片', list: pictures, cover: pictures[0].pic})
      }
      return arr
    },
  },
  watch: {
    dialogVisible (val) {
      if(!val) {
        this.$refs.vueRef.pause()
      }
    },
    banner (val) {
      this.showBannerList = val[0] && val[0].list
    },
    showBannerList (val) {
      this.srcList =  val && val.map(item => item.pic)
    }
  },
  methods: {
    watchDetail (item) {
      this.activeVideoInfo = item
      this.dialogVisible = true
    },
    changePicList (item, index) {
      this.showBannerList = item.list
      this.active = index
    },
    prev () {
      if (this.active === 0) {
        this.active = this.banner.length - 1
      } else {
        this.active -= 1
      }
      this.showBannerList = this.banner[this.active].list
    },
    next () {
      if (this.active === (this.banner && this.banner.length - 1) || (this.banner && this.banner.length === 0)) {
        this.active = 0
      } else {
        this.active += 1
      }
      this.showBannerList = this.banner[this.active].list
    },
    preVideo () {
      if (this.showBannerActive === 0) {
        this.showBannerActive = this.showBannerList.length - 1
      } else {
        this.showBannerActive -= 1
      }
      this.activeVideoInfo = this.showBannerList[this.showBannerActive]
    },
    nextVideo () {
      if (this.showBannerActive === (this.banner && this.banner.length - 1) || (this.banner && this.banner.length) === 0) {
        this.showBannerActive = 0
      } else {
        this.showBannerActive += 1
      }
      this.activeVideoInfo = this.showBannerList[this.showBannerActive]
    },
    // 查看微沙盘
    shapanDetail (content) {
      const { rid, vrUrl, pcRid, vrUrlPc } = content
      if (vrUrlPc) {
        this.shapanVrUrl = vrUrlPc
        this.goVrPage(this.shapanVrUrl, 'pc')
      } else if (pcRid) {
        axios.get(`https://xfj.coli688.com/super-gw/user-info/sand-box/shares/resources/${pcRid}`)
          .then(res=>{
            const url = res.data.data.wechat_shares.jump_url || ''
            const newUrl = url.replace(/_saas/,"")
            this.shapanVrUrl = newUrl
            this.goVrPage(this.shapanVrUrl, 'pc')
          })
      } else if (vrUrl) {
        this.shapanVrUrl = vrUrl
        this.goVrPage(this.shapanVrUrl, '')
      } else if (rid) {
        axios.get(`https://xfj.coli688.com/super-gw/user-info/sand-box/shares/resources/${rid}`)
        .then(res=>{
          const url = res.data.data.wechat_shares.jump_url || ''
          const newUrl = url.replace(/_saas/,"")
          this.shapanVrUrl = newUrl
          this.goVrPage(this.shapanVrUrl, '')
        })
      }
    },
    goVrPage (vrUrl, type) {
      setTimeout(() => {
        const routeData = this.$router.resolve({
          path: "/vrView",
          query: { vrUrl, pageFrom: 'back', type }
        })
        window.open(routeData.href, '_blank')
      },500)
    }
  }
}
</script>
<style lang="scss" scoped>
.project-picture{
  position: relative;
  margin-bottom: 60px;
  .img-wrap{
    position: relative;
    img{
      width: 710px;
      height: 532px;
    }
    .shapan-tip{
      cursor: pointer;
      position: absolute;
      top: 50px;
      right: 0;
      bottom: 0;
      left: 0;
      margin: auto;
      top: 0;
      width: 70px;
      height: 70px;
      border-radius: 50%;
      // border: 2px solid hsla(0deg, 0%, 100%, 0.5);
      // background: rgba(0, 0, 0, 0.6);
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      font-size: 28px;
      line-height: 43px;
      font-weight: 400;
      color: #333;
      color: #fff;
      z-index: 3;
      &::before {
        content: "";
        display: inline-block;
        background: url(https://xfjoss.coli688.com/pc-images/big-sand-icon.png);
        background-size: cover;
        width: 67px;
        height: 67px;
        display: block;
      }
    }
    .video-btn {
      cursor: pointer;
      position: absolute;
      top: 50px;
      right: 0;
      bottom: 0;
      left: 0;
      margin: auto;
      top: 0;
      width: 70px;
      height: 70px;
      border-radius: 50%;
      // border: 2px solid hsla(0deg, 0%, 100%, 0.5);
      // background: rgba(0, 0, 0, 0.6);
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      font-size: 28px;
      line-height: 43px;
      font-weight: 400;
      color: #333;
      color: #fff;
      z-index: 100;
      &::before {
        content: "";
        display: inline-block;
        background: url(https://xfjoss.coli688.com/pc-images/play-icon.png);
        background-size: cover;
        width: 67px;
        height: 67px;
        display: block;
      }
    }
  }
  .small-pics{
    width: 100%;
    height: 90px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-top: 8px;
    > div {
      display: inline-block;
    }
    .pic-wrap{
      width: calc(100% - 62px);
    }
    .left-btn, .right-btn{
      width: 31px;
      height: 90px;
      background: rgba(0, 0, 0, 0.5);
      border-radius: 2px;
      line-height: 90px;
      text-align: center;
      color: #fff;
      font-size: 24px;
      cursor: pointer;
    }
    .pic-wrap{
      font-size: 0;
      .pic{
        display: inline-block;
        cursor: pointer;
        position: relative;
        width: 120px;
        height: 90px;
        margin-left: 8px;
        img{
          width: 120px;
          height: 90px;
          cursor: pointer;
        }
        .type-name{
          position: absolute;
          bottom: 0;
          width: 100%;
          height: 30px;
          background: rgba(0, 0, 0);
          opacity: 0.5;
          text-align: center;
          @include font12(400, #fff);
          line-height: 30px;
        }
        .active{
          background: #BDA26C;
          opacity: 1;
        }
      }
    }
  }
  .pop-dialog-wrap {

    .video-prev, .video-next{
      position: absolute;
      width: 44px;
      height: 44px;
      border-radius: 50%;
      font-size: 24px;
      color: #fff;
      background-color: #606266;
      border-color: #fff;
      text-align: center;
      line-height: 44px;
      cursor: pointer;
    }
    .video-prev{
      top: 50%;
      left: -100%;
    }
    .video-next{
      top: 50%;
      right: -100%;
    }
  }

}
</style>
<style lang="scss">
.project-picture{
  .el-carousel__arrow{
    width: 44px;
    height: 44px;
    font-size: 24px;
    color: #BDA26C;
    background: rgba(0, 0, 0, 0.5);
    z-index: 3;
  }
}


</style>


